// 总路由目录
export const routerMain = [
    {
        path: '/',
        title: '用户管理',
        icon: 'nav_icon18.png',
        children: [
            {
                path: '/miniUser',
                title: '用户管理',
                component: () => import('@/components/main/main.vue'),
                children: [
                    {
                        path: '/miniUser',
                        name: 'miniUser',
                        title: '用户管理',
                        component: () => import('@/view/miniUser/miniUser.vue'),
                    },
                ]
            },
        ]
    },
    {
        path: '/',
        title: '权益包管理',
        icon: 'nav_icon18.png',
        children: [
            {
                path: '/quityGroup',
                title: '权益包管理',
                icon: 'nav_icon110.png',
                activeIcon: 'nav_icon110-active.png',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/quityGroup',
                        name: 'quityGroup',
                        title: '权益包管理',
                        component: () => import('@/view/quityGroup/quityGroup.vue'),
                    },
                    {
                        path: '/quityGroupAudit',
                        name: 'quityGroupAudit',
                        title: '权益审核管理',
                        component: () => import('@/view/quityGroup/quityGroupAudit.vue'),
                    },
                    {
                        path: '/quityGroupLog',
                        name: 'quityGroupLog',
                        title: '权益日志管理',
                        component: () => import('@/view/quityGroup/quityGroupLog.vue'),
                    },
                ]
            },
        ]
    },
    {
        path: '/',
        title: '退款管理',
        icon: 'nav_icon18.png',
        children: [
            {
                path: '/refundManage',
                title: '退款管理',
                icon: 'nav_icon110.png',
                activeIcon: 'nav_icon110-active.png',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/refundManage',
                        name: 'refundManage',
                        title: '退款申诉管理',
                        component: () => import('@/view/refund/refundManage.vue'),
                    },
                    {
                        path: '/refundFinalAudit',
                        name: 'refundFinalAudit',
                        title: '退款复核管理',
                        component: () => import('@/view/refund/refundFinalAudit.vue'),
                    },
                ]
            },
            {
                path: '/paymentQuery',
                title: '微信流水查询',
                icon: 'nav_icon110.png',
                activeIcon: 'nav_icon110-active.png',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/paymentQuery',
                        name: 'paymentQuery',
                        title: '微信流水查询',
                        component: () => import('@/view/refund/paymentQuery.vue'),
                    },
                ]
            },
        ]
    },
    // 系统设置
    {
        path: '/',
        title: '系统设置',
        icon: 'nav_icon24.png',
        children: [
            {
                path: '/user',
                title: '用户管理',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/user',
                        name: 'user',
                        title: '用户管理',
                        component: () => import('@/view/system/user.vue'),
                    },
                ]
            },
            {
                path: '/role',
                title: '角色管理',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/role',
                        name: 'role',
                        title: '角色管理',
                        component: () => import('@/view/system/role.vue'),
                    },
                ]
            },
            {
                path: '/menu',
                title: '菜单管理',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/menu',
                        name: 'menu',
                        title: '菜单管理',
                        component: () => import('@/view/system/menu.vue'),
                    },
                ]
            },
            {
                path: '/systemConfig',
                title: '参数配置',
                icon: 'nav_icon110.png',
                activeIcon: 'nav_icon110-active.png',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/systemConfig',
                        name: 'systemConfig',
                        title: '参数配置',
                        component: () => import('@/view/system/systemConfig.vue'),
                    },
                ]
            },
            {
                path: '/dictType',
                title: '字典类型',
                icon: 'nav_icon110.png',
                activeIcon: 'nav_icon110-active.png',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/dictType',
                        name: 'dictType',
                        title: '字典类型',
                        component: () => import('@/view/dictData/dictType.vue'),
                    },
                ]
            },
            {
                path: '/dictData',
                title: '字典数据',
                icon: 'nav_icon110.png',
                activeIcon: 'nav_icon110-active.png',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/dictData',
                        name: 'dictData',
                        title: '字典数据',
                        component: () => import('@/view/dictData/dictData.vue'),
                    },
                ]
            },
            {
                path: '/fileManage',
                title: '文件管理',
                icon: 'nav_icon110.png',
                activeIcon: 'nav_icon110-active.png',
                component: () => import('@/view/main/main.vue'),
                children: [
                    {
                        path: '/fileManage',
                        name: 'fileManage',
                        title: '文件管理',
                        component: () => import('@/view/fileManage/fileManage.vue'),
                    },
                ]
            },
        ]
    },
    
];



// WEBPACK FOOTER //
// ./src/router/routerList.js